// extracted by mini-css-extract-plugin
export default {"button":"bn-z","reviewSort":"cn-z"};